import React from 'react'

export default function YouAreBannedView () {
  return (
    <div id='you-are-banned'>
      <h1>You are banned</h1>
      <p>You have been banned from the social space. If you believe you have been banned in error, please email <b>contact at roguelike.club</b>.</p>
    </div>
  )
}
